import script from "./WaitingLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./WaitingLoader.vue?vue&type=script&setup=true&lang=ts"

import "./WaitingLoader.vue?vue&type=style&index=0&id=4909631a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4909631a"]])

export default __exports__